// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import { Avatar } from 'antd';
import React, { ReactElement, ReactNode, useEffect, useRef } from 'react';
import { THTooltip } from '@Molecules/THTooltip/THTooltip';

import './UserAvatar.scss';

interface UserAvatarProps {
    avatar?: string | ReactNode;
    name?: string;
    tooltipCustom?: string;
    className?: string;
    size?: number | 'small' | 'large';
    onClick?: (event: MouseEvent) => void;
    showTooltip?: boolean;
}

const UserAvatar = ({
    avatar,
    name,
    size = 'small',
    className,
    onClick,
    showTooltip = false,
    tooltipCustom = '',
}: UserAvatarProps): ReactElement => {
    const avatarRef = useRef<HTMLElement>(null);

    const userLetter = name?.charAt(0).toUpperCase() || '?';

    useEffect(() => {
        if (avatarRef.current && onClick) {
            avatarRef.current.onclick = (event) => onClick(event);
        }
    }, [onClick]);

    return (
        <THTooltip title={showTooltip && (tooltipCustom || name)} placement="top">
            <Avatar
                ref={avatarRef}
                src={avatar}
                size={size}
                className={classList('user-avatar', className, { clickable: !!onClick })}
            >
                {userLetter}
            </Avatar>
        </THTooltip>
    );
};

export default UserAvatar;
